import { GeldProvider } from './lib/geld';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './lib/auth-context';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <GeldProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
        </GeldProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA (caching + offline + push).
// In development we skip registration zodat Vite HMR niet botst met de cache.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('SW register failed:', err);
    });
  });
}
